import { Box, Header, Text, addWithConfig } from '@rbilabs/universal-components';

import ActionButtonLink from 'components/action-button';
import { theme } from 'styles/configure-theme';

export const EmptyScreenWrapper = Box.withConfig({
  justifyContent: 'center',
  alignItems: 'center',
  margin: 0,
  color: theme.token('text-default'),
  marginTop: '$10',
});

export const StyledActionButtonLink = addWithConfig(ActionButtonLink).withConfig({
  style: { marginTop: 16 },
  width: '$80',
});

export const HeaderText = Header.withConfig({
  variant: 'headerOne',
  margin: 0,
  fontSize: 'xl',
  lineHeight: 'md',
  marginTop: '$4',
});

export const SubText = Text.withConfig({
  variant: 'copyOne',
  marginTop: '$4',
  marginX: '$8',
  marginBottom: '$0',
  fontSize: 'md',
  textAlign: 'center',
});

export const ImageWrapper = Box.withConfig({
  height: '$32',
  width: 'full',
  alignItems: 'center',
  marginBottom: '$10',
});
